import { Instance } from 'mobx-state-tree';
import { PlanningActionsDtoModelBase } from './PlanningActionsDtoModel.base';

/* The TypeScript type of an instance of PlanningActionsDtoModel */
export interface PlanningActionsDtoModelType extends Instance<typeof PlanningActionsDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionsDtoModel */
export { selectFromPlanningActionsDto, planningActionsDtoModelPrimitives, PlanningActionsDtoModelSelector } from './PlanningActionsDtoModel.base';

/**
 * PlanningActionsDtoModel
 */
export const PlanningActionsDtoModel = PlanningActionsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
